export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/calendar/Constants.js
// module id = 280
// module chunks = 0